import {
    setCurrentIntervention,
    interventionsIsLoading,
    generateBlocs,
    setPreview,
    setControlSignature,
    setSignature,
    validateBlocs,
    validateBloc,
    setImputationRedirectionModalOpenned,
    setFilteredAndSortedInterventions,
    getWorkOrderById,
} from "./interventionActions";
import { throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import db from "../../db";
import { clone, guid } from "../../utils";
import moment, { isMoment } from "moment";
import {
    buildAndCreateImputationFromWorkOrder,
    completeImputationFromWorkOrder,
    addTimeSlotBloc,
    completeTimeSlotBloc,
} from "../imputationInterventionRel/imputationInterventionRelActions";
import { createOrGetDayByDate } from "../day/dayActions";
import { getDayString, floatToTime } from "../../time";
import { isInterventionTerminated } from "./interventionStatusActions";
import { getDefaultPosition } from "../gps/gpsActions";
import {
    TIME_SLOT_BLOC_TYPE_CODE,
    TIME_SLOT_START_DAY,
    TIME_SLOT_START_TIME,
    SIGNATURES_BLOC_TYPE_CODE,
} from "./interventionConstants";
import {
    adaptBlocsForOpenERP,
    adaptInterventionForOpenERP,
    adaptInterventionForMyOpen,
} from "../../redux/intervention/interventionsCast";
import { searchSPP } from "../simplifiedPreventPlan/simplifiedPreventPlanActions";

function createInterventionIfNecessary(intervention, user, blocTypes, history, stateAccessor, imputationInformations) {
    return (dispatch) => {
        return new Promise((resolve) => {
            if (intervention.id) return resolve(intervention);
            else
                return dispatch(
                    createIntervention(intervention, user, blocTypes, history, stateAccessor, imputationInformations)
                )
                    .then((intervention) => {
                        return resolve(intervention);
                    })
                    .catch((err) => resolve(err)); //Ce n'est pas grave, on réessaiera plus tard
        });
    };
}

function generateImputationInformationsFromTimeSlot(blocs, blocTypes, user) {
    let timeSlotBlocType = blocTypes.find((bt) => bt.code === TIME_SLOT_BLOC_TYPE_CODE);

    if (!timeSlotBlocType) {
        console.error("Le type de bloc plage horaire [" + TIME_SLOT_BLOC_TYPE_CODE + "] est introuvable");
        return;
    }

    let blocsFound = blocs.filter(
        (b) => b.type_id === timeSlotBlocType.id && (b.create_uid === user.id || !b.create_uid)
    );

    if (blocsFound.length <= 0) {
        throw new Error("La plage horaire en cours est introuvable");
    }

    let inProgressTimeSlotBloc = blocsFound.sort((a, b) =>
        moment(a.mobile_creation_date).diff(moment(b.mobile_creation_date))
    )[0];

    let timeSlotFieldTypeStartDateId = timeSlotBlocType.field_ids.find((f) => f.code === TIME_SLOT_START_DAY);
    let timeSlotFieldTypeStartTimeId = timeSlotBlocType.field_ids.find((f) => f.code === TIME_SLOT_START_TIME);

    let timeSlotStartDateFieldValue = inProgressTimeSlotBloc.field_ids.find(
        (f) => f.type_id === timeSlotFieldTypeStartDateId.id
    ).value_date;
    let timeSlotStartTimeFieldValue = inProgressTimeSlotBloc.field_ids.find(
        (f) => f.type_id === timeSlotFieldTypeStartTimeId.id
    ).value_float;

    return {
        startDate: moment(timeSlotStartDateFieldValue),
        startTime: moment(floatToTime(timeSlotStartTimeFieldValue)),
        gpsPosition: getDefaultPosition(),
    };
}

export function createAndStartIntervention(
    intervention,
    user,
    blocTypes,
    history,
    stateAccessor,
    imputationInformations
) {
    return (dispatch) => {
        dispatch(interventionsIsLoading(true));
        dispatch(createIntervention(intervention, user, blocTypes, history, stateAccessor, imputationInformations))
            .then((createdIntervention) => {
                dispatch(
                    startIntervention(
                        createdIntervention,
                        imputationInformations,
                        blocTypes,
                        user,
                        history,
                        stateAccessor
                    )
                );
                dispatch(interventionsIsLoading(false));
            })
            .catch((err) => {
                console.error(err);
                //Si la création échoue, on start quand même (forceStateAsStarted)
                dispatch(forceStateAsStarted(intervention, imputationInformations, blocTypes, user, stateAccessor))
                    .then((updatedIntervention) => {
                        updatedIntervention.locallyModified = false;
                        updatedIntervention.notSynchronised = true;
                        updatedIntervention = adaptInterventionForMyOpen(updatedIntervention);
                        // updatedIntervention.date_planned_start = isMoment(intervention.date_planned_start) ? intervention.date_planned_start.format("DD/MM/YYYY HH:mm") : intervention.date_planned_start;
                        // updatedIntervention.date_call = isMoment(intervention.date_call) ? intervention.date_call.format("DD/MM/YYYY HH:mm") : intervention.date_call;
                        submitInterventionInDb(updatedIntervention, updatedIntervention.report_block_ids)
                            .then(() => {
                                dispatch(setCurrentIntervention(updatedIntervention));
                                redirectToIntervention(history);
                                dispatch(interventionsIsLoading(false));
                            })
                            .catch((err) => {
                                dispatch(interventionsIsLoading(false));
                                console.error(err);
                            });
                    })
                    .catch((err) => {
                        dispatch(interventionsIsLoading(false));
                        console.error("Une erreur s'est produite lors du forcing du démarrage de l'OT", err);
                    });
            });
    };
}

export function createIntervention(intervention, user, blocTypes, history, stateAccessor, imputationInformations) {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            const headers = new Headers({ "Content-Type": "application/json" });
            let interventionGuid = guid();

            if (!imputationInformations)
                imputationInformations = generateImputationInformationsFromTimeSlot(
                    intervention.report_block_ids,
                    blocTypes,
                    user
                );

            intervention.myOpenStartDate = imputationInformations.startTime.format("DD/MM/YYYY HH:mm");

            if (stateAccessor.intervention) {
                stateAccessor.intervention.myOpenStartDate = intervention.myOpenStartDate;
                if (stateAccessor.intervention.delivery_customer_id) {
                    stateAccessor.sppFound = await searchSPP(
                        stateAccessor.intervention.delivery_customer_id.id,
                        stateAccessor.intervention.date_planned_start
                    );
                }
            }

            if (!intervention.mobile_id) intervention.mobile_id = interventionGuid;

            if (!intervention.report_block_ids || intervention.report_block_ids.length <= 0) {
                let blocs = generateBlocs(blocTypes, intervention, user, stateAccessor);
                let transformedBlocs = adaptBlocsForOpenERP(blocs);
                intervention.report_block_ids = transformedBlocs;
            }

            let interventionForOpenErp = adaptInterventionForOpenERP(intervention);

            const body = {
                intervention: interventionForOpenErp,
                userId: user.id,
            };

            dispatch(interventionsIsLoading(true));

            fetchWithTimeout("/api/v1/interventions/create", {
                method: "POST",
                headers: headers,
                body: JSON.stringify(body),
                timeout: 30000,
            })
                .then(function (response) {
                    if (!response.ok) throw Error(response.statusText);

                    return response;
                })
                .then((response) => response.json())
                .then((synchronizedIntervention) => {
                    synchronizedIntervention = adaptInterventionForMyOpen(synchronizedIntervention);
                    synchronizedIntervention.internalState = intervention.internalState;
                    synchronizedIntervention.locallyModified = false;
                    intervention.date_planned_start = isMoment(intervention.date_planned_start)
                        ? intervention.date_planned_start.format("DD/MM/YYYY HH:mm")
                        : intervention.date_planned_start;
                    intervention.date_call = isMoment(intervention.date_call)
                        ? intervention.date_call.format("DD/MM/YYYY HH:mm")
                        : intervention.date_call;
                    submitInterventionInDb(synchronizedIntervention, synchronizedIntervention.report_block_ids)
                        .then(() => {
                            dispatch(setCurrentIntervention(synchronizedIntervention));
                            redirectToIntervention(history);
                            dispatch(interventionsIsLoading(false));
                            return resolve(synchronizedIntervention);
                        })
                        .catch((err) => {
                            dispatch(interventionsIsLoading(false));
                            return reject(err);
                        });

                    /*if (intervention.internalState === "started") {
                        //Intervention déjà créée dans MyOpen
                        //Pas besoin de créer une nouvelle imputation ou une nouvelle plage
                        intervention = adaptInterventionForMyOpen(intervention);
                        intervention.locallyModified = false;
                        submitInterventionInDb(intervention, intervention.report_block_ids).then(() => {
                            dispatch(setCurrentIntervention(intervention))
                            redirectToIntervention(history);
                            dispatch(interventionsIsLoading(false));
                        }).catch((err) => {
                            throw err;
                        })

                        return resolve(intervention);
                    } else {
                        dispatch(forceStateAsStarted(synchronizedIntervention, imputationInformations, blocTypes, user, stateAccessor)).then((updatedIntervention) => {
                            updatedIntervention = adaptInterventionForMyOpen(updatedIntervention);
                            updatedIntervention.locallyModified = false;
                            submitInterventionInDb(updatedIntervention, updatedIntervention.report_block_ids).then(() => {
                                dispatch(setCurrentIntervention(updatedIntervention))
                                redirectToIntervention(history);
                                dispatch(interventionsIsLoading(false));
                            }).catch((err) => {
                                throw err;
                            })

                            return resolve(updatedIntervention);
                        });
                    }*/
                })
                .catch((err) => {
                    console.error("Erreur : interventionEditionActions - createIntervention: " + err.message);
                    dispatch(
                        throwErrorMessage({
                            title: "Erreur",
                            message: "Une erreur s'est produite lors de la création de l'OT",
                        })
                    );

                    intervention = adaptInterventionForMyOpen(intervention);
                    intervention.notSynchronised = true;
                    //intervention.date_planned_start = isMoment(intervention.date_planned_start) ? intervention.date_planned_start.format("DD/MM/YYYY HH:mm") : intervention.date_planned_start;
                    //intervention.date_call = isMoment(intervention.date_call) ? intervention.date_call.format("DD/MM/YYYY HH:mm") : intervention.date_call;
                    submitInterventionInDb(intervention, intervention.report_block_ids)
                        .then(() => {
                            redirectToIntervention(history);
                            dispatch(interventionsIsLoading(false));
                            return reject(intervention);
                        })
                        .catch((err) => {
                            console.error(
                                "Erreur : interventionEditionActions - createIntervention (démarrage): " + err.message
                            );
                            dispatch(
                                throwErrorMessage({
                                    title: "Erreur",
                                    message: "Une erreur s'est produite lors du démarrage de l'intervention",
                                })
                            );
                            dispatch(interventionsIsLoading(false));
                            return reject(intervention);
                        });
                    dispatch(setCurrentIntervention(intervention));
                    /*if (intervention.internalState === "started") {
                        //Intervention déjà créée dans MyOpen
                        //Pas besoin de créer une nouvelle imputation ou une nouvelle plage
                        intervention.notSynchronised = true;
                        intervention.date_planned_start = isMoment(intervention.date_planned_start) ? intervention.date_planned_start.format("DD/MM/YYYY HH:mm") : intervention.date_planned_start;
                        intervention.date_call = isMoment(intervention.date_call) ? intervention.date_call.format("DD/MM/YYYY HH:mm") : intervention.date_call;
                        submitInterventionInDb(intervention, intervention.report_block_ids).then(() => {
                            redirectToIntervention(history);
                            dispatch(interventionsIsLoading(false));
                            return resolve(intervention);
                        }).catch((err) => {
                            console.error("Erreur : interventionEditionActions - createIntervention (démarrage): " + err.message);
                            dispatch(throwErrorMessage({
                                title: "Erreur",
                                message: "Une erreur s'est produite lors du démarrage de l'intervention",
                            }))
                            dispatch(interventionsIsLoading(false));
                        });
                    } else {
                        dispatch(forceStateAsStarted(intervention, imputationInformations, blocTypes, user, stateAccessor)).then((updatedIntervention) => {
                            updatedIntervention.notSynchronised = true;
                            updatedIntervention.date_planned_start = isMoment(intervention.date_planned_start) ? intervention.date_planned_start.format("DD/MM/YYYY HH:mm") : intervention.date_planned_start;
                            updatedIntervention.date_call = isMoment(intervention.date_call) ? intervention.date_call.format("DD/MM/YYYY HH:mm") : intervention.date_call;
                            submitInterventionInDb(updatedIntervention, updatedIntervention.report_block_ids).then(() => {
                                redirectToIntervention(history);
                                dispatch(interventionsIsLoading(false));
                                return resolve(updatedIntervention);
                            }).catch((err) => {
                                console.error("Erreur : interventionEditionActions - createIntervention (démarrage): " + err.message);
                                dispatch(throwErrorMessage({
                                    title: "Erreur",
                                    message: "Une erreur s'est produite lors du démarrage de l'intervention",
                                }))
                                dispatch(interventionsIsLoading(false));
                            });
                        }).catch((err) => {
                            console.error("Erreur : interventionEditionActions - createIntervention (démarrage): " + err.message);
                            dispatch(throwErrorMessage({
                                title: "Erreur",
                                message: "Une erreur s'est produite lors du démarrage de l'intervention",
                            }))
                            dispatch(interventionsIsLoading(false));
                        })
                    }*/
                });
        });
    };
}

function redirectToIntervention(history) {
    history.push("/interventions/intervention");
}

export function preview(history) {
    return (dispatch) => {
        dispatch(setPreview(true));
        history.push("/interventions/intervention/preview");
    };
}

export function cancelPreview(history, imputationRedirection) {
    return (dispatch) => {
        dispatch(setPreview(false));
        history.push("/interventions/intervention");
        if (imputationRedirection) dispatch(setImputationRedirectionModalOpenned(true));
    };
}

export function controlSignature(history) {
    return (dispatch) => {
        dispatch(setControlSignature(true));
        history.push("/interventions/intervention/controlSignature");
    };
}

export function cancelControlSignature(history, imputationRedirection) {
    return (dispatch) => {
        dispatch(setControlSignature(false));
        history.push("/interventions/intervention");
        if (imputationRedirection) dispatch(setImputationRedirectionModalOpenned(true));
    };
}

export function signature(history) {
    return (dispatch) => {
        dispatch(setSignature(true));
        history.push("/interventions/intervention/signature");
    };
}

export function cancelSignature(history, imputationRedirection) {
    return (dispatch) => {
        dispatch(setSignature(false));
        history.push("/interventions/intervention/controlSignature");
        if (imputationRedirection) dispatch(setImputationRedirectionModalOpenned(true));
    };
}

export function validateSignature(intervention, timeSlot, blocs, user, blocTypes, history, stateAccessor) {
    return (dispatch) => {
        if (intervention.internalState !== "started") {
            dispatch(
                throwErrorMessage({
                    title: "Erreur",
                    message: "Impossible de valider une intervention non démarrée",
                })
            );

            return;
        }

        intervention.report_block_ids = blocs;

        dispatch(createInterventionIfNecessary(intervention, user, blocTypes, history, stateAccessor))
            .then(async (createdIntervention) => {
                dispatch(interventionsIsLoading(true));
                let startDay = await createOrGetDayByDate(user.id, getDayString(timeSlot.startDate.toDate()), true);
                timeSlot.startDay = startDay;

                if (timeSlot.endDate) {
                    let endDay = await createOrGetDayByDate(user.id, getDayString(timeSlot.endDate.toDate()), true);
                    timeSlot.endDay = endDay;
                }

                let blocSignatureType = blocTypes.find((bt) => bt.code === SIGNATURES_BLOC_TYPE_CODE);
                let blocSignature = blocs.find((b) => b.type_id === blocSignatureType.id);

                let newBlocs = blocs.filter((b) => b.type_id !== blocSignatureType.id);

                if (createdIntervention.tec_manager_id.id !== user.emp_id) {
                    dispatch(
                        validateBloc(
                            blocSignature,
                            intervention,
                            blocs,
                            blocTypes,
                            blocSignatureType,
                            stateAccessor,
                            user
                        )
                    )
                        .then((bloc) => {
                            newBlocs.push(bloc);
                            createdIntervention.report_block_ids = newBlocs;
                            dispatch(completeTimeSlotBloc(newBlocs, blocTypes, createdIntervention, user, timeSlot))
                                .then((updatedIntervention) => {
                                    dispatch(
                                        completeImputationFromWorkOrder(updatedIntervention, timeSlot, user)
                                    ).catch((err) => {
                                        console.error(err);
                                        dispatch(
                                            throwErrorMessage({
                                                title: "Erreur lors de l'arrêt de l'imputation",
                                                message:
                                                    "Veuillez arrêter l'imputation directement depuis la saisie des temps",
                                            })
                                        );
                                    });

                                    createdIntervention.internalState = "validated-report";
                                    dispatch(
                                        synchronizeIntervention(
                                            updatedIntervention,
                                            updatedIntervention.report_block_ids,
                                            user,
                                            blocTypes,
                                            history,
                                            stateAccessor
                                        )
                                    );
                                    dispatch(cancelSignature(history, true));
                                    dispatch(interventionsIsLoading(false));

                                    return;
                                })
                                .catch((err) => {
                                    console.error(
                                        "Erreur : interventionEditionActions - validateSignature (assistant): ",
                                        err
                                    );
                                    dispatch(
                                        throwErrorMessage({
                                            title: "Erreur",
                                            message: "Une erreur s'est produite lors de la validation de l'OT",
                                        })
                                    );

                                    dispatch(interventionsIsLoading(false));
                                    return;
                                });
                        })
                        .catch((err) => {
                            console.error("Erreur : interventionEditionActions - validateSignature (assistant): ", err);
                            dispatch(
                                throwErrorMessage({
                                    title: "Erreur",
                                    message: "Une erreur s'est produite lors de la validation de l'OT",
                                })
                            );

                            dispatch(interventionsIsLoading(false));
                            return;
                        });
                    return;
                }

                dispatch(
                    validateBloc(blocSignature, intervention, blocs, blocTypes, blocSignatureType, stateAccessor, user)
                )
                    .then((bloc) => {
                        newBlocs.push(bloc);
                        createdIntervention.report_block_ids = newBlocs;
                        dispatch(completeTimeSlotBloc(newBlocs, blocTypes, createdIntervention, user, timeSlot))
                            .then((updatedIntervention) => {
                                const headers = new Headers({
                                    "Content-Type": "application/json",
                                });
                                let interventionGuid = updatedIntervention.mobile_id;
                                let transformedBlocs = adaptBlocsForOpenERP(newBlocs);
                                const body = {
                                    interventionId: updatedIntervention.id,
                                    blocs: transformedBlocs,
                                    userId: user.id,
                                };

                                submitInterventionInDb(updatedIntervention, updatedIntervention.report_block_ids);

                                dispatch(completeImputationFromWorkOrder(updatedIntervention, timeSlot, user)).catch(
                                    (err) => {
                                        console.error(err);
                                        dispatch(
                                            throwErrorMessage({
                                                title: "Erreur lors de l'arrêt de l'imputation",
                                                message:
                                                    "Veuillez arrêter l'imputation directement depuis la saisie des temps",
                                            })
                                        );
                                    }
                                );

                                fetchWithTimeout("/api/v1/interventions/validate", {
                                    method: "POST",
                                    headers: headers,
                                    body: JSON.stringify(body),
                                })
                                    .then(function (response) {
                                        if (!response.ok) throw Error(response.statusText);

                                        return response;
                                    })
                                    .then((response) => response.json())
                                    .then((value) => {
                                        value.mobile_id = interventionGuid;
                                        intervention = adaptInterventionForMyOpen(value);
                                        intervention.internalState = "started";
                                        intervention.locallyModified = false;
                                        dispatch(setCurrentIntervention(intervention));

                                        submitInterventionInDb(intervention, intervention.report_block_ids).then(() => {
                                            dispatch(interventionsIsLoading(false));
                                        });

                                        dispatch(cancelSignature(history, true));
                                    })
                                    .catch((err) => {
                                        console.error("Erreur : interventionEditionActions - validateSignature: ", err);
                                        dispatch(
                                            throwErrorMessage({
                                                title: "Erreur",
                                                message: "Une erreur s'est produite lors de la validation de l'OT",
                                            })
                                        );

                                        dispatch(interventionsIsLoading(false));
                                    });
                            })
                            .catch((err) => {
                                console.error("Erreur : interventionEditionActions - validateSignature: ", err);
                                dispatch(
                                    throwErrorMessage({
                                        title: "Erreur",
                                        message: "Une erreur s'est produite lors de la validation de l'OT",
                                    })
                                );

                                dispatch(interventionsIsLoading(false));
                            });
                    })
                    .catch((err) => {
                        console.error("Erreur : interventionEditionActions - validateSignature: ", err);
                        dispatch(
                            throwErrorMessage({
                                title: "Erreur",
                                message: "Une erreur s'est produite lors de la validation de l'OT",
                            })
                        );

                        dispatch(interventionsIsLoading(false));
                    });
            })
            .catch((err) => {
                console.error("Erreur : interventionEditionActions - validateSignature: ", err);
                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message: "Une erreur s'est produite lors de la validation de l'OT",
                    })
                );

                dispatch(interventionsIsLoading(false));
            });
    };
}

export function stopAndValidateIntervention(intervention, timeSlot, blocs, user, blocTypes, history, stateAccessor) {
    return (dispatch) => {
        if (intervention.internalState !== "started") {
            dispatch(
                throwErrorMessage({
                    title: "Erreur",
                    message: "Impossible de valider une intervention non démarrée",
                })
            );

            return;
        }

        intervention.report_block_ids = blocs;

        dispatch(createInterventionIfNecessary(intervention, user, blocTypes, history, stateAccessor))
            .then(async (createdIntervention) => {
                dispatch(interventionsIsLoading(true));
                let startDay = await createOrGetDayByDate(user.id, getDayString(timeSlot.startDate.toDate()), true);
                timeSlot.startDay = startDay;

                if (timeSlot.endDate) {
                    let endDay = await createOrGetDayByDate(user.id, getDayString(timeSlot.endDate.toDate()), true);
                    timeSlot.endDay = endDay;
                }

                if (createdIntervention.tec_manager_id.id !== user.emp_id) {
                    dispatch(
                        validateBlocs(
                            createdIntervention.report_block_ids,
                            createdIntervention,
                            blocTypes,
                            user,
                            stateAccessor
                        )
                    )
                        .then((updatedBlocs) => {
                            createdIntervention.report_block_ids = updatedBlocs;
                            dispatch(completeTimeSlotBloc(updatedBlocs, blocTypes, createdIntervention, user, timeSlot))
                                .then((updatedIntervention) => {
                                    dispatch(
                                        completeImputationFromWorkOrder(updatedIntervention, timeSlot, user)
                                    ).catch((err) => {
                                        console.error(err);
                                        dispatch(
                                            throwErrorMessage({
                                                title: "Erreur lors de l'arrêt de l'imputation",
                                                message:
                                                    "Veuillez arrêter l'imputation directement depuis la saisie des temps",
                                            })
                                        );
                                    });

                                    createdIntervention.internalState = "validated-report";
                                    dispatch(
                                        synchronizeIntervention(
                                            updatedIntervention,
                                            updatedIntervention.report_block_ids,
                                            user,
                                            blocTypes,
                                            history,
                                            stateAccessor
                                        )
                                    );
                                    dispatch(cancelPreview(history, true));
                                    dispatch(interventionsIsLoading(false));

                                    return;
                                })
                                .catch((err) => {
                                    console.error(
                                        "Erreur : interventionEditionActions - stopAndValidateIntervention (assistant): ",
                                        err
                                    );
                                    dispatch(
                                        throwErrorMessage({
                                            title: "Erreur",
                                            message: "Une erreur s'est produite lors de la validation de l'OT",
                                        })
                                    );

                                    dispatch(interventionsIsLoading(false));
                                    return;
                                });
                        })
                        .catch((err) => {
                            console.error(
                                "Erreur : interventionEditionActions - stopAndValidateIntervention (assistant): ",
                                err
                            );
                            dispatch(
                                throwErrorMessage({
                                    title: "Erreur",
                                    message: "Une erreur s'est produite lors de la validation de l'OT",
                                })
                            );

                            dispatch(interventionsIsLoading(false));
                            return;
                        });
                    return;
                }

                dispatch(
                    validateBlocs(
                        createdIntervention.report_block_ids,
                        createdIntervention,
                        blocTypes,
                        user,
                        stateAccessor
                    )
                )
                    .then((updatedBlocs) => {
                        createdIntervention.report_block_ids = updatedBlocs;
                        dispatch(completeTimeSlotBloc(updatedBlocs, blocTypes, createdIntervention, user, timeSlot))
                            .then((updatedIntervention) => {
                                const headers = new Headers({
                                    "Content-Type": "application/json",
                                });
                                let interventionGuid = updatedIntervention.mobile_id;
                                let transformedBlocs = adaptBlocsForOpenERP(updatedBlocs);
                                const body = {
                                    interventionId: updatedIntervention.id,
                                    blocs: transformedBlocs,
                                    userId: user.id,
                                };

                                submitInterventionInDb(updatedIntervention, updatedIntervention.report_block_ids);

                                dispatch(completeImputationFromWorkOrder(updatedIntervention, timeSlot, user)).catch(
                                    (err) => {
                                        console.error(err);
                                        dispatch(
                                            throwErrorMessage({
                                                title: "Erreur lors de l'arrêt de l'imputation",
                                                message:
                                                    "Veuillez arrêter l'imputation directement depuis la saisie des temps",
                                            })
                                        );
                                    }
                                );

                                fetchWithTimeout("/api/v1/interventions/validate", {
                                    method: "POST",
                                    headers: headers,
                                    body: JSON.stringify(body),
                                })
                                    .then(function (response) {
                                        if (!response.ok) throw Error(response.statusText);

                                        return response;
                                    })
                                    .then((response) => response.json())
                                    .then((value) => {
                                        value.mobile_id = interventionGuid;
                                        intervention = adaptInterventionForMyOpen(value);
                                        intervention.internalState = "started";
                                        intervention.locallyModified = false;
                                        dispatch(setCurrentIntervention(intervention));

                                        submitInterventionInDb(intervention, intervention.report_block_ids).then(() => {
                                            dispatch(interventionsIsLoading(false));
                                        });

                                        dispatch(cancelPreview(history, true));
                                    })
                                    .catch((err) => {
                                        console.error(
                                            "Erreur : interventionEditionActions - stopAndValidateIntervention: ",
                                            err
                                        );
                                        dispatch(
                                            throwErrorMessage({
                                                title: "Erreur",
                                                message: "Une erreur s'est produite lors de la validation de l'OT",
                                            })
                                        );

                                        dispatch(interventionsIsLoading(false));
                                    });
                            })
                            .catch((err) => {
                                console.error(
                                    "Erreur : interventionEditionActions - stopAndValidateIntervention: ",
                                    err
                                );
                                dispatch(
                                    throwErrorMessage({
                                        title: "Erreur",
                                        message: "Une erreur s'est produite lors de la validation de l'OT",
                                    })
                                );

                                dispatch(interventionsIsLoading(false));
                            });
                    })
                    .catch((err) => {
                        console.error("Erreur : interventionEditionActions - stopAndValidateIntervention: ", err);
                        dispatch(
                            throwErrorMessage({
                                title: "Erreur",
                                message: "Une erreur s'est produite lors de la validation de l'OT",
                            })
                        );

                        dispatch(interventionsIsLoading(false));
                    });
            })
            .catch((err) => {
                console.error("Erreur : interventionEditionActions - stopAndValidateIntervention: ", err);
                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message: "Une erreur s'est produite lors de la validation de l'OT",
                    })
                );

                dispatch(interventionsIsLoading(false));
            });
    };
}

function forceStateAsStarted(intervention, imputationInformations, blocTypes, user, stateAccessor) {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            if (!imputationInformations) {
                intervention.internalState = "started";
                if (intervention.state !== "performed") intervention.state = "performed";

                dispatch(setCurrentIntervention(intervention));
                submitInterventionInDb(intervention, intervention.report_block_ids);

                return resolve(intervention);
            }

            let startDay = await createOrGetDayByDate(
                user.id,
                getDayString(imputationInformations.startDate.toDate()),
                true
            );
            imputationInformations.startDay = startDay;

            dispatch(
                addTimeSlotBloc(
                    intervention.report_block_ids,
                    blocTypes,
                    intervention,
                    user,
                    imputationInformations.startDate,
                    imputationInformations.startTime,
                    stateAccessor
                )
            )
                .then((updatedIntervention) => {
                    updatedIntervention.internalState = "started";
                    if (updatedIntervention.state !== "performed") updatedIntervention.state = "performed";

                    dispatch(setCurrentIntervention(updatedIntervention));
                    submitInterventionInDb(updatedIntervention, updatedIntervention.report_block_ids);

                    dispatch(buildAndCreateImputationFromWorkOrder(intervention, imputationInformations, user)).catch(
                        (err) => {
                            console.error(err);
                            dispatch(
                                throwErrorMessage({
                                    title: "Erreur lors de la création de l'imputation",
                                    message: "Veuillez créer l'imputation directement depuis la saisie des temps",
                                })
                            );
                        }
                    );

                    return resolve(updatedIntervention);
                })
                .catch((err) => {
                    console.error(err);
                    return reject(err);
                });
        });
    };
}

function forceStateAsPaused(intervention, timeSlot, blocTypes, user, currentIntervention = true) {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            let startDay = await createOrGetDayByDate(user.id, getDayString(timeSlot.startDate.toDate()), true);
            timeSlot.startDay = startDay;

            if (timeSlot.endDate) {
                let endDay = await createOrGetDayByDate(user.id, getDayString(timeSlot.endDate.toDate()), true);
                timeSlot.endDay = endDay;
            }

            dispatch(completeTimeSlotBloc(intervention.report_block_ids, blocTypes, intervention, user, timeSlot))
                .then((updatedIntervention) => {
                    updatedIntervention.internalState = "paused";
                    if (currentIntervention) {
                        dispatch(setCurrentIntervention(updatedIntervention));
                    }

                    submitInterventionInDb(updatedIntervention, updatedIntervention.report_block_ids).catch((err) => {
                        console.error(err);
                        dispatch(
                            throwErrorMessage({
                                title: "Erreur lors de l'interruption de l'OT",
                            })
                        );
                    });

                    dispatch(completeImputationFromWorkOrder(intervention, timeSlot, user)).catch((err) => {
                        console.error(err);
                        dispatch(
                            throwErrorMessage({
                                title: "Erreur lors de l'arrêt de l'imputation",
                                message: "Veuillez arrêter l'imputation directement depuis la saisie des temps",
                            })
                        );
                    });

                    return resolve(updatedIntervention);
                })
                .catch((err) => {
                    console.error(err);
                    return reject(err);
                });
        });
    };
}

export function startIntervention(intervention, imputationInformations, model, user, history, stateAccessor) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(interventionsIsLoading(true));
            getWorkOrderById(intervention.id).then((intervention) => {
                dispatch(
                    createInterventionIfNecessary(
                        intervention,
                        user,
                        model,
                        history,
                        stateAccessor,
                        imputationInformations
                    )
                )
                    .then((createdIntervention) => {
                        let clonedIntervention = clone(createdIntervention);
                        dispatch(
                            forceStateAsStarted(clonedIntervention, imputationInformations, model, user, stateAccessor)
                        )
                            .then((updatedIntervention) => {
                                const headers = new Headers({
                                    "Content-Type": "application/json",
                                });
                                updatedIntervention.myOpenStartDate =
                                    imputationInformations.startTime.format("DD/MM/YYYY HH:mm");

                                if (stateAccessor.intervention)
                                    stateAccessor.intervention.myOpenStartDate = updatedIntervention.myOpenStartDate;

                                // Recherche de la présence des blocs de base
                                db.Intervention.toArray().then((dbInterventions) => {
                                    let dbIntervention = dbInterventions.find(
                                        (i) => i.id === intervention.id || i.mobile_id === intervention.mobile_id
                                    );

                                    let blocs = dbIntervention.report_block_ids
                                        ? [...dbIntervention.report_block_ids]
                                        : [];

                                    let baseBlocs = blocs.filter((b) =>
                                        model.find((bt) => bt.create_by_default === "ot_manager" && bt.id === b.type_id)
                                    );
                                    if (baseBlocs.length <= 0) {
                                        let baseBlocs = generateBlocs(model, updatedIntervention, user, stateAccessor);
                                        baseBlocs.forEach((b) => {
                                            if (
                                                !blocs.some(
                                                    (existing) =>
                                                        existing.type_id === b.type_id &&
                                                        existing.mobile_id === b.mobile_id
                                                )
                                            ) {
                                                blocs.push(b);
                                            }
                                        });
                                        submitInterventionInDb(updatedIntervention, blocs);
                                    }
                                    let transformedBlocs = adaptBlocsForOpenERP(blocs);
                                    let interventionGuid = updatedIntervention.mobile_id;
                                    const body = {
                                        interventionId: updatedIntervention.id,
                                        blocs: transformedBlocs,
                                        userId: user.id,
                                    };

                                    dispatch(setCurrentIntervention(updatedIntervention, blocs));

                                    fetchWithTimeout("/api/v1/interventions/start", {
                                        method: "POST",
                                        headers: headers,
                                        body: JSON.stringify(body),
                                    })
                                        .then(function (response) {
                                            if (!response.ok) throw Error(response.statusText);

                                            return response;
                                        })
                                        .then((response) => response.json())
                                        .then((value) => {
                                            value.mobile_id = interventionGuid;
                                            let synchronizedIntervention = adaptInterventionForMyOpen(value);
                                            synchronizedIntervention.locallyModified = false;
                                            synchronizedIntervention.internalState = "started";

                                            submitInterventionInDb(
                                                synchronizedIntervention,
                                                synchronizedIntervention.report_block_ids
                                            ).then(() => {
                                                dispatch(
                                                    setCurrentIntervention(
                                                        synchronizedIntervention,
                                                        synchronizedIntervention.report_block_ids
                                                    )
                                                );
                                            });

                                            dispatch(interventionsIsLoading(false));
                                            return resolve();
                                        })
                                        .catch((err) => {
                                            console.error(
                                                "Erreur : interventionEditionActions - startIntervention: " +
                                                    err.message
                                            );
                                            dispatch(
                                                throwErrorMessage({
                                                    title: "Erreur",
                                                    message: "Une erreur s'est produite lors du démarrage de l'OT",
                                                })
                                            );

                                            dispatch(interventionsIsLoading(false));
                                            return reject(err);
                                        });
                                });
                            })
                            .catch((err) => {
                                console.error(
                                    "Erreur : interventionEditionActions - startIntervention: " + err.message
                                );
                                dispatch(interventionsIsLoading(false));
                                return reject(err);
                            });
                    })
                    .catch((err) => {
                        console.error("Erreur : interventionEditionActions - startIntervention: " + err.message);
                        dispatch(interventionsIsLoading(false));
                        return reject(err);
                    });
            });
        });
    };
}

export function pauseIntervention(
    intervention,
    timeSlot,
    blocs,
    user,
    blocTypes,
    history,
    stateAccessor,
    keepLoading = false,
    currentIntervention = true
) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            intervention.report_block_ids = blocs;
            dispatch(forceStateAsPaused(intervention, timeSlot, blocTypes, user, currentIntervention))
                .then((intervention) => {
                    return dispatch(
                        synchronizeIntervention(
                            intervention,
                            intervention.report_block_ids,
                            user,
                            blocTypes,
                            history,
                            stateAccessor,
                            true,
                            keepLoading,
                            currentIntervention,
                            stateAccessor
                        )
                    )
                        .then((intervention) => resolve(intervention))
                        .catch((err) => {
                            console.error(err);
                            //Ici si la synchro échoue, ce n'est pas grave
                            //On considère que le job est fait grace au forcing de l'état en pause
                            return resolve(err);
                        });
                })
                .catch((err) => {
                    console.error(err);
                    return reject(err);
                });
        });
    };
}

export function synchronizeIntervention(
    intervention,
    blocs,
    user,
    blocTypes,
    history,
    stateAccessor,
    pause = false,
    keepLoading = false,
    currentIntervention = true
) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            intervention.report_block_ids = blocs;
            dispatch(interventionsIsLoading(true));
            return dispatch(createInterventionIfNecessary(intervention, user, blocTypes, history, stateAccessor))
                .then((createdIntervention) => {
                    const headers = new Headers({ "Content-Type": "application/json" });
                    let transformedBlocs = adaptBlocsForOpenERP(blocs);
                    let interventionGuid = createdIntervention.mobile_id;
                    const body = {
                        interventionId: createdIntervention.id,
                        blocs: transformedBlocs,
                        userId: user.id,
                    };

                    return fetchWithTimeout("/api/v1/interventions/synchronize_data", {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify(body),
                    })
                        .then(function (response) {
                            if (!response.ok) throw Error(response.statusText);

                            return response;
                        })
                        .then((response) => response.json())
                        .then((value) => {
                            value.mobile_id = interventionGuid;
                            let synchronizedIntervention = adaptInterventionForMyOpen(value);

                            if (pause) synchronizedIntervention.internalState = "paused";
                            else synchronizedIntervention.internalState = intervention.internalState;

                            synchronizedIntervention.locallyModified = false;
                            submitInterventionInDb(
                                synchronizedIntervention,
                                synchronizedIntervention.report_block_ids
                            ).then(() => {
                                if (currentIntervention)
                                    dispatch(
                                        setCurrentIntervention(
                                            synchronizedIntervention,
                                            synchronizedIntervention.report_block_ids
                                        )
                                    );

                                return resolve(synchronizedIntervention);
                            });

                            if (!keepLoading) dispatch(interventionsIsLoading(false));
                        })
                        .catch((err) => {
                            console.error(
                                "Erreur : interventionEditionActions - synchronizeIntervention: " + err.message
                            );
                            dispatch(
                                throwErrorMessage({
                                    title: "Erreur",
                                    message: "Une erreur s'est produite lors de la synchronisation de l'OT",
                                })
                            );

                            if (!keepLoading) dispatch(interventionsIsLoading(false));

                            return reject(err);
                        });
                })
                .catch((err) => {
                    console.error("Erreur : interventionEditionActions - synchronizeIntervention: " + err.message);
                    dispatch(
                        throwErrorMessage({
                            title: "Erreur",
                            message: "Une erreur s'est produite lors de la synchronisation de l'OT",
                        })
                    );

                    if (!keepLoading) dispatch(interventionsIsLoading(false));

                    return reject(err);
                });
        });
    };
}

export function submitInterventionInDb(intervention, blocs) {
    return new Promise((resolve, reject) => {
        blocs.forEach((b) => {
            b.mobile_write_date = b.mobile_write_date ? b.mobile_write_date.toString() : undefined;
            b.mobile_creation_date = b.mobile_creation_date ? b.mobile_creation_date.toString() : undefined;

            b.field_ids.forEach((f) => {
                f.value_date = f.value_date ? moment(f.value_date).format("YYYY-MM-DD HH:mm:ss") : undefined;
            });
        });

        intervention.report_block_ids = blocs;
        return db
            .transaction("rw?", db.Intervention, () => {
                return db.Intervention.filter((currentIntervention) => {
                    return (
                        (currentIntervention.mobile_id && currentIntervention.mobile_id === intervention.mobile_id) ||
                        (currentIntervention.id && currentIntervention.id === intervention.id)
                    );
                })
                    .toArray()
                    .then((interventions) => {
                        let clonedIntervention = clone(intervention);
                        clonedIntervention.date_planned_start = moment(clonedIntervention.date_planned_start).format(
                            "YYYY-MM-DD HH:mm:ss"
                        );
                        clonedIntervention.date_call = moment(clonedIntervention.date_call).format(
                            "YYYY-MM-DD HH:mm:ss"
                        );

                        if (interventions.length === 0) {
                            db.Intervention.put(clonedIntervention)
                                .then((createdIntervention) => {
                                    return resolve(createdIntervention);
                                })
                                .catch((err) => {
                                    console.error(err);
                                    return reject(err);
                                });
                        } else {
                            db.Intervention.update(clonedIntervention.mobile_id, clonedIntervention)
                                .then((updatedInterventionByMobileId) => {
                                    return resolve(updatedInterventionByMobileId);
                                })
                                .catch((err) => {
                                    console.error(err);
                                    return resolve(db.Intervention.update(clonedIntervention.id, clonedIntervention));
                                });
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        return reject(err);
                    });
            })
            .catch((err) => {
                console.error(err);
                return reject(err);
            });
    });
}

export function removeIntervention(intervention, history, interventionsFilters) {
    return (dispatch) => {
        db.Intervention.delete(intervention.mobile_id);
        if (interventionsFilters) dispatch(setFilteredAndSortedInterventions(interventionsFilters));

        history.push("/interventions");
    };
}

export function cleanOldInterventions(interventionsFilters) {
    return (dispatch) => {
        db.transaction("rw?", db.Intervention, () => {
            let interventionsToDelete = [];
            db.Intervention.toArray()
                .then((interventions) => {
                    let fiftyDaysAgo = moment().add(-15, "day");

                    interventions.forEach((intervention) => {
                        let interventionDate = moment(new Date(intervention.startDate));
                        if (
                            interventionDate < fiftyDaysAgo &&
                            isInterventionTerminated(intervention.state, intervention.internalState)
                        ) {
                            interventionsToDelete.push(intervention);
                        }
                    });

                    return interventionsToDelete;
                })
                .then((interventionsToDelete) => {
                    interventionsToDelete.forEach((intervention) => {
                        db.Intervention.delete(intervention.mobile_id);
                    });
                })
                .catch((err) => {
                    console.error("Erreur : interventionEditionActions - cleanOldInterventions");
                    let message = "Une erreur s'est produite lors de la purge des anciennes interventions";

                    dispatch(
                        throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: message,
                        })
                    );
                });
        })
            .then(() => {
                dispatch(setFilteredAndSortedInterventions(interventionsFilters));
            })
            .catch((err) => {
                console.error("Erreur : interventionEditionActions - cleanOldInterventions");
                let message = "Une erreur s'est produite lors de la purge des anciennes interventions";

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: message,
                    })
                );
            });
    };
}
